import React from "react";
import {
  ClampAlert,
  type ClampAlertProps,
} from "@/features/betslip/components/parts/ClampAlert";

import * as styles from "./PickSlipAlert.module.scss";

type PickSlipAlertProps = ClampAlertProps;

const PickSlipAlert = (props: PickSlipAlertProps) => {
  return <ClampAlert className={styles.container} {...props} />;
};

export { PickSlipAlert };
